<template>
	<div class="navCard_secondNavbarView" :class="{'navCard_showNavView': showNav}">
		<div class="navCard_secondNavView">
			<div class="chess_centerView">
				<div class="chess_itemView game_maintainTY" v-if="getGame('OBQP').on_line == 0" :class="{'game_maintain': getGame('OBQP').maintain == 1}"  @click="link('OBQP')">
					<div class="chess_venueInfo">
						<div class="logoBg_logoBgView"
							>
							<my-img srcText="header/header-nav-3/icon1.png" class="chess_logoIcon" />
						</div>
						<div class="chess_infoView">
							<div class="chess_venueCn">{{$t('main.game.qp.ob.name')}}<div
									class="officialLogo_officialLogoView chess_officialIcon"
									style="background-image: url(&quot;data:image/png;base64,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&quot;);">
									<span>官方</span>
								</div>
							</div>
							<div class="chess_venueEn">OB BOARDGAME</div>
						</div>
					</div>
					<div class="image_imageContainer image_cover chess_imgIcon"
						style="cursor: inherit;">
						<div>
							<my-img srcText="header/header-nav-3/image-1.png" styleText="position: absolute; top: 0px; left: 0px; bottom: 0px; right: 0px; box-sizing: border-box; padding: 0px; border: none; margin: auto; display: block; width: 0px; height: 0px; min-width: 100%; max-width: 100%; min-height: 100%; max-height: 100%; object-fit: cover; filter: none; background-image: none;" />
						</div>
					</div>
				</div>
				<div class="chess_itemView game_maintainTY" v-if="getGame('KY').on_line == 0" :class="{'game_maintain': getGame('KY').maintain == 1}"  @click="link('KY')">
					<div class="chess_venueInfo">
						<div class="logoBg_logoBgView"
							>
						<my-img srcText="header/header-nav-3/icon3.png" class="chess_logoIcon" />
						</div>
						<div class="chess_infoView">
							<div class="chess_venueCn">{{$t('main.game.qp.ky.name')}}</div>
							<div class="chess_venueEn">KY BOARDGAME</div>
						</div>
					</div>
					<div class="image_imageContainer image_cover chess_imgIcon"
						style="cursor: inherit;">
						<div>
							<my-img srcText="header/header-nav-3/image-2.png" styleText="position: absolute; top: 0px; left: 0px; bottom: 0px; right: 0px; box-sizing: border-box; padding: 0px; border: none; margin: auto; display: block; width: 0px; height: 0px; min-width: 100%; max-width: 100%; min-height: 100%; max-height: 100%; object-fit: cover; filter: none; background-image: none;" />
						</div>
					</div>
				</div>
				<div class="chess_itemView game_maintainTY" v-if="getGame('LEG').on_line == 0" :class="{'game_maintain': getGame('LEG').maintain == 1}"  @click="link('LEG')">
					<div class="chess_venueInfo">
						<div class="logoBg_logoBgView"
							>
							<my-img srcText="header/header-nav-3/icon5.png" class="chess_logoIcon" />
						</div>
						<div class="chess_infoView">
							<div class="chess_venueCn">{{$t('main.game.qp.yl.name')}}</div>
							<div class="chess_venueEn">LEG BOARDGAME</div>
						</div>
					</div>
					<div class="image_imageContainer image_cover chess_imgIcon"
						style="cursor: inherit;">
						<div>
							<my-img srcText="header/header-nav-3/image-3.png" styleText="position: absolute; top: 0px; left: 0px; bottom: 0px; right: 0px; box-sizing: border-box; padding: 0px; border: none; margin: auto; display: block; width: 0px; height: 0px; min-width: 100%; max-width: 100%; min-height: 100%; max-height: 100%; object-fit: cover; filter: none; background-image: none;" />
						</div>
					</div>
				</div>
				<div class="chess_itemView game_maintainTY" v-if="getGame('VG').on_line == 0" :class="{'game_maintain': getGame('VG').maintain == 1}" @click="link('VG')">
					<div class="chess_venueInfo">
						<div class="logoBg_logoBgView"
							>
							<my-img srcText="header/header-nav-3/icon7.png" class="chess_logoIcon" />
						</div>
						<div class="chess_infoView">
							<div class="chess_venueCn">{{$t('main.game.qp.vg.name')}}</div>
							<div class="chess_venueEn">VG BOARDGAME</div>
						</div>
					</div>
					<div class="image_imageContainer image_cover chess_imgIcon"
						style="cursor: inherit;">
						<div>
							<my-img srcText="header/header-nav-3/image-4.png" styleText="position: absolute; top: 0px; left: 0px; bottom: 0px; right: 0px; box-sizing: border-box; padding: 0px; border: none; margin: auto; display: block; width: 0px; height: 0px; min-width: 100%; max-width: 100%; min-height: 100%; max-height: 100%; object-fit: cover; filter: none; background-image: none;" />
						</div>
					</div>
				</div>
				<div class="chess_itemView game_maintainTY" v-if="getGame('MT').on_line == 0" :class="{'game_maintain': getGame('MT').maintain == 1}" @click="link('MT')">
					<div class="chess_venueInfo">
						<div class="logoBg_logoBgView"
							>
							<my-img srcText="header/header-nav-3/icon16.png" class="chess_logoIcon" />
						</div>
						<div class="chess_infoView">
							<div class="chess_venueCn">{{$t('main.game.qp.mt.name')}}</div>
							<div class="chess_venueEn">SG BOARDGAME</div>
						</div>
					</div>
					<div class="image_imageContainer image_cover chess_imgIcon"
						style="cursor: inherit;">
						<div>
							<my-img srcText="header/header-nav-3/obqp.png" styleText="position: absolute; top: 0px; left: 0px; bottom: 0px; right: 0px; box-sizing: border-box; padding: 0px; border: none; margin: auto; display: block; width: 0px; height: 0px; min-width: 100%; max-width: 100%; min-height: 100%; max-height: 100%; object-fit: cover; filter: none; background-image: none;" />
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import http from '@/http.js'
	export default {
		props: ['showNav', 'NewArrs'],
		data() {
			return {
				
			}
		},
		methods: {
			getGame (type) {
				let data = {}
				this.NewArrs.forEach((v) => {
					if (v.plat_type == type) {
						data = v
					}
				})
				return data
			},
			link(type) {
				let self = this
				if (!localStorage.getItem('access_token')) {
					let wxts = this.$t('main.login_ts')
					this.$confirm({
						title: this.$t('main.wxts'),
						content: h => < div > {wxts} </div>,
						okText: this.$t('main.okText'),
						cancelText: this.$t('main.cancelText'),
						onOk() {
							self.$router.push({
							  path: "/login",
							});
						},
						onCancel() {
						},
						class: 'testbo',
					});
				} else {
					let data = {
						gameData: {}
					}
					this.NewArrs.forEach((v) => {
						if (v.plat_type == type) {
							data.gameData = v
						}
					})
					let href = window.location.origin +
						`/game?plat_type=${data.gameData.plat_type}&game_type=${data.gameData.game_type}&game_code=${data.gameData.game_code}`;
					// this.$store.dispatch('user/getNewGidBalanceTime')
					// window.open(href, "_blank");
					this.$store.dispatch('user/linkGamePage', {
						href: href,
						platType: data.gameData.plat_type,
						gameName: data.gameData.name
					})
				}
			}
		}
	};
</script>

<style scoped lang="less">
	.image_imageContainer {
		position: relative;
	}

	.navCard_secondNavbarView {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 390px;
		padding-top: 90px;
		background-color: #fff;
		overflow: hidden;
		-webkit-transition: opacity .8s ease, -webkit-transform .5s ease;
		transition: opacity .8s ease, -webkit-transform .5s ease;
		transition: transform .5s ease, opacity .8s ease;
		transition: transform .5s ease, opacity .8s ease, -webkit-transform .5s ease;
		z-index: 80;
		-webkit-transform: translateY(-100%);
		transform: translateY(-100%);
		opacity: 0;
		// background-image: url(../../../assets/header/header-nav-1/icon10.png);
		background-image: url(/assets/header/header-nav-1/icon10.png);
		background-size: 100% 390px;
		background-position: top;
	}

	.navCard_showNavView {
		transform: translateY(0);
		opacity: 1;
		box-shadow: 0 6px 19px 0 hsla(0, 0%, 40%, .27);
	}

	.navCard_secondNavbarView.navCard_showNavView {
		-webkit-transform: translateY(0);
		transform: translateY(0);
		opacity: 1;
		box-shadow: 0 6px 19px 0 hsla(0, 0%, 40%, .27);
	}

	.navCard_secondNavbarView .navCard_secondNavView {
		width: 1200px;
		height: 100%;
		margin: 0 auto;
		display: -webkit-flex;
		display: flex;
		-webkit-justify-content: space-between;
		justify-content: space-between;
		overflow: hidden;
	}

	.realbet_centerView {
		width: 1050px;
		display: -webkit-flex;
		display: flex;
		-webkit-justify-content: space-between;
		justify-content: space-between;
		position: relative
	}


	.chess_centerView {
		display: -webkit-flex;
		display: flex;
		-webkit-justify-content: center;
		justify-content: center;
		cursor: pointer;
		width: 100%;
		
	}

	.chess_centerView .chess_officialIcon {
		position: absolute;
		top: 50%;
		right: -40px;
		-webkit-transform: translateY(-50%);
		transform: translateY(-50%)
	}

	.chess_centerView .chess_itemView {
		position: relative;
		display: -webkit-flex;
		display: flex;
		-webkit-flex-direction: column;
		flex-direction: column;
		-webkit-align-items: center;
		align-items: center;
		width: 266px;
		margin-top: 20px;
		-webkit-transition: all .2s ease;
		transition: all .2s ease
	}

	.chess_centerView .chess_itemView .chess_imgIcon {
		width: 210px;
		height: 210px;
		-webkit-transition: all .3s;
		transition: all .3s;
		margin-right: 4px
	}

	.chess_centerView .chess_itemView:hover .chess_imgIcon {
		-webkit-transform: scale(1.1) translateZ(0);
		transform: scale(1.1) translateZ(0)
	}

	.chess_centerView .chess_itemView .chess_venueInfo {
		display: -webkit-flex;
		display: flex;
		-webkit-align-items: center;
		align-items: center;
		-webkit-flex-direction: row;
		flex-direction: row
	}

	.chess_centerView .chess_itemView .chess_venueInfo .chess_logoIcon {
		width: 44px;
		height: auto
	}

	.chess_centerView .chess_itemView .chess_venueInfo .chess_infoView {
		width: 100%
	}

	.chess_centerView .chess_itemView .chess_venueInfo .chess_infoView .chess_venueCn {
		position: relative;
		line-height: 21px;
		margin-bottom: 2px;
		font-size: 16px;
		font-weight: 600;
		color: #6c7ba8
	}

	.chess_centerView .chess_itemView .chess_venueInfo .chess_infoView .chess_venueEn {
		line-height: 16px;
		font-size: 12px;
		color: #6c7ba8;
		white-space: nowrap
	}

	.chess_rightView {
		min-width: 120px
	}

	.chess_rightView .chess_topIcon {
		width: 127px;
		height: auto;
		margin-top: 66px
	}

	.chess_rightView p {
		font-size: 14px;
		color: #67718f
	}

	.chess_rightView .chess_bottomIcon {
		width: 112px;
		height: auto
	}

	.chess_maskClass__2oZK8 {
		width: 260px !important;
		height: 260px !important;
		top: 0 !important
	}

	.judgeVenueStatus_isBanned__2cpSM {
		position: relative
	}

	.judgeVenueStatus_isBanned__2cpSM .judgeVenueStatus_mask__1Csuz {
		display: -webkit-flex;
		display: flex;
		-webkit-justify-content: center;
		justify-content: center;
		width: 100%;
		height: 100%;
		position: absolute;
		left: 0;
		top: 0
	}

	.judgeVenueStatus_isBanned__2cpSM .judgeVenueStatus_mask__1Csuz h2 {
		color: #fff !important;
		font-size: 30px !important;
		line-height: 42px;
		font-family: PingFangSC;
		margin-bottom: 4px
	}

	.judgeVenueStatus_isBanned__2cpSM .judgeVenueStatus_mask__1Csuz .judgeVenueStatus_bigMaskContent__2g2gE,
	.judgeVenueStatus_isBanned__2cpSM .judgeVenueStatus_mask__1Csuz .judgeVenueStatus_maskContent__17vDb,
	.judgeVenueStatus_isBanned__2cpSM .judgeVenueStatus_mask__1Csuz .judgeVenueStatus_middleMaskContent__23b9W,
	.judgeVenueStatus_isBanned__2cpSM .judgeVenueStatus_mask__1Csuz .judgeVenueStatus_smallMaskContent__1ndlF,
	.judgeVenueStatus_isBanned__2cpSM .judgeVenueStatus_mask__1Csuz .judgeVenueStatus_twoContentMaskContent__2j8iO {
		position: absolute;
		width: 160px;
		height: 180px;
		border-radius: 8px;
		text-align: center;
		display: -webkit-flex;
		display: flex;
		-webkit-flex-flow: column;
		flex-flow: column;
		-webkit-justify-content: center;
		justify-content: center;
		-webkit-align-items: center;
		align-items: center;
		z-index: 2
	}

	.judgeVenueStatus_isBanned__2cpSM .judgeVenueStatus_mask__1Csuz .judgeVenueStatus_bigMaskContent__2g2gE:after,
	.judgeVenueStatus_isBanned__2cpSM .judgeVenueStatus_mask__1Csuz .judgeVenueStatus_maskContent__17vDb:after,
	.judgeVenueStatus_isBanned__2cpSM .judgeVenueStatus_mask__1Csuz .judgeVenueStatus_middleMaskContent__23b9W:after,
	.judgeVenueStatus_isBanned__2cpSM .judgeVenueStatus_mask__1Csuz .judgeVenueStatus_smallMaskContent__1ndlF:after,
	.judgeVenueStatus_isBanned__2cpSM .judgeVenueStatus_mask__1Csuz .judgeVenueStatus_twoContentMaskContent__2j8iO:after {
		content: "";
		background-color: #6c7ba8;
		width: 100%;
		height: 100%;
		opacity: .7;
		position: absolute;
		z-index: -1;
		border-radius: 8px
	}

	.judgeVenueStatus_isBanned__2cpSM .judgeVenueStatus_mask__1Csuz .judgeVenueStatus_bigMaskContent__2g2gE h2,
	.judgeVenueStatus_isBanned__2cpSM .judgeVenueStatus_mask__1Csuz .judgeVenueStatus_maskContent__17vDb h2,
	.judgeVenueStatus_isBanned__2cpSM .judgeVenueStatus_mask__1Csuz .judgeVenueStatus_middleMaskContent__23b9W h2,
	.judgeVenueStatus_isBanned__2cpSM .judgeVenueStatus_mask__1Csuz .judgeVenueStatus_smallMaskContent__1ndlF h2,
	.judgeVenueStatus_isBanned__2cpSM .judgeVenueStatus_mask__1Csuz .judgeVenueStatus_twoContentMaskContent__2j8iO h2 {
		color: #fff !important;
		font-size: 30px !important;
		line-height: 42px;
		font-family: PingFangSC;
		margin-bottom: 4px
	}

	.judgeVenueStatus_isBanned__2cpSM .judgeVenueStatus_mask__1Csuz .judgeVenueStatus_bigMaskContent__2g2gE div,
	.judgeVenueStatus_isBanned__2cpSM .judgeVenueStatus_mask__1Csuz .judgeVenueStatus_maskContent__17vDb div,
	.judgeVenueStatus_isBanned__2cpSM .judgeVenueStatus_mask__1Csuz .judgeVenueStatus_middleMaskContent__23b9W div,
	.judgeVenueStatus_isBanned__2cpSM .judgeVenueStatus_mask__1Csuz .judgeVenueStatus_smallMaskContent__1ndlF div,
	.judgeVenueStatus_isBanned__2cpSM .judgeVenueStatus_mask__1Csuz .judgeVenueStatus_twoContentMaskContent__2j8iO div {
		color: #fff !important
	}

	.judgeVenueStatus_isBanned__2cpSM .judgeVenueStatus_mask__1Csuz .judgeVenueStatus_bigMaskContent__2g2gE p,
	.judgeVenueStatus_isBanned__2cpSM .judgeVenueStatus_mask__1Csuz .judgeVenueStatus_maskContent__17vDb p,
	.judgeVenueStatus_isBanned__2cpSM .judgeVenueStatus_mask__1Csuz .judgeVenueStatus_middleMaskContent__23b9W p,
	.judgeVenueStatus_isBanned__2cpSM .judgeVenueStatus_mask__1Csuz .judgeVenueStatus_smallMaskContent__1ndlF p,
	.judgeVenueStatus_isBanned__2cpSM .judgeVenueStatus_mask__1Csuz .judgeVenueStatus_twoContentMaskContent__2j8iO p {
		margin: 0 auto;
		color: #fff !important
	}

	.judgeVenueStatus_isBanned__2cpSM .judgeVenueStatus_mask__1Csuz .judgeVenueStatus_bigMaskContent__2g2gE .judgeVenueStatus_date__21MY9,
	.judgeVenueStatus_isBanned__2cpSM .judgeVenueStatus_mask__1Csuz .judgeVenueStatus_maskContent__17vDb .judgeVenueStatus_date__21MY9,
	.judgeVenueStatus_isBanned__2cpSM .judgeVenueStatus_mask__1Csuz .judgeVenueStatus_middleMaskContent__23b9W .judgeVenueStatus_date__21MY9,
	.judgeVenueStatus_isBanned__2cpSM .judgeVenueStatus_mask__1Csuz .judgeVenueStatus_smallMaskContent__1ndlF .judgeVenueStatus_date__21MY9,
	.judgeVenueStatus_isBanned__2cpSM .judgeVenueStatus_mask__1Csuz .judgeVenueStatus_twoContentMaskContent__2j8iO .judgeVenueStatus_date__21MY9 {
		font-size: 14px;
		line-height: 16px;
		font-family: DINPro
	}

	.judgeVenueStatus_isBanned__2cpSM .judgeVenueStatus_mask__1Csuz .judgeVenueStatus_bigMaskContent__2g2gE .judgeVenueStatus_time__W_4q9,
	.judgeVenueStatus_isBanned__2cpSM .judgeVenueStatus_mask__1Csuz .judgeVenueStatus_maskContent__17vDb .judgeVenueStatus_time__W_4q9,
	.judgeVenueStatus_isBanned__2cpSM .judgeVenueStatus_mask__1Csuz .judgeVenueStatus_middleMaskContent__23b9W .judgeVenueStatus_time__W_4q9,
	.judgeVenueStatus_isBanned__2cpSM .judgeVenueStatus_mask__1Csuz .judgeVenueStatus_smallMaskContent__1ndlF .judgeVenueStatus_time__W_4q9,
	.judgeVenueStatus_isBanned__2cpSM .judgeVenueStatus_mask__1Csuz .judgeVenueStatus_twoContentMaskContent__2j8iO .judgeVenueStatus_time__W_4q9 {
		font-size: 24px;
		line-height: 30px;
		font-weight: 700;
		font-family: DINPro
	}

	.judgeVenueStatus_isBanned__2cpSM .judgeVenueStatus_mask__1Csuz .judgeVenueStatus_bigMaskContent__2g2gE {
		width: 580px;
		height: 180px;
		top: 60px;
		left: 155px;
		-webkit-justify-content: space-between;
		justify-content: space-between;
		padding: 30px 0
	}

	.judgeVenueStatus_isBanned__2cpSM .judgeVenueStatus_mask__1Csuz .judgeVenueStatus_bigMaskContent__2g2gE>section {
		display: -webkit-flex;
		display: flex;
		-webkit-justify-content: space-between;
		justify-content: space-between;
		-webkit-align-items: center;
		align-items: center;
		margin-top: 15px
	}

	.judgeVenueStatus_isBanned__2cpSM .judgeVenueStatus_mask__1Csuz .judgeVenueStatus_bigMaskContent__2g2gE>section p {
		line-height: 20px;
		font-size: 18px;
		margin-left: 12px;
		margin-right: 12px
	}

	.judgeVenueStatus_isBanned__2cpSM .judgeVenueStatus_mask__1Csuz .judgeVenueStatus_bigMaskContent__2g2gE .judgeVenueStatus_time__W_4q9 {
		font-size: 20px;
		line-height: 24px;
		height: 24px;
		margin-top: 5px
	}

	.judgeVenueStatus_isBanned__2cpSM .judgeVenueStatus_mask__1Csuz .judgeVenueStatus_middleMaskContent__23b9W {
		width: 235px;
		height: 180px;
		top: 69px;
		-webkit-justify-content: space-between;
		justify-content: space-between;
		padding: 30px 0
	}

	.judgeVenueStatus_isBanned__2cpSM .judgeVenueStatus_mask__1Csuz .judgeVenueStatus_middleMaskContent__23b9W>section {
		display: -webkit-flex;
		display: flex;
		-webkit-justify-content: space-between;
		justify-content: space-between;
		-webkit-align-items: center;
		align-items: center;
		margin-top: 15px
	}

	.judgeVenueStatus_isBanned__2cpSM .judgeVenueStatus_mask__1Csuz .judgeVenueStatus_middleMaskContent__23b9W>section p {
		line-height: 46px;
		font-size: 18px;
		margin-left: 12px;
		margin-right: 12px
	}

	.judgeVenueStatus_isBanned__2cpSM .judgeVenueStatus_mask__1Csuz .judgeVenueStatus_middleMaskContent__23b9W .judgeVenueStatus_time__W_4q9 {
		font-size: 20px;
		line-height: 24px;
		height: 24px;
		margin-top: 5px
	}

	.judgeVenueStatus_isBanned__2cpSM .judgeVenueStatus_mask__1Csuz .judgeVenueStatus_smallMaskContent__1ndlF {
		width: 162px;
		height: 204px;
		top: 48px
	}

	.judgeVenueStatus_isBanned__2cpSM .judgeVenueStatus_mask__1Csuz .judgeVenueStatus_smallMaskContent__1ndlF>section p {
		line-height: 20px;
		font-size: 14px
	}

	.judgeVenueStatus_isBanned__2cpSM .judgeVenueStatus_mask__1Csuz .judgeVenueStatus_smallMaskContent__1ndlF .judgeVenueStatus_time__W_4q9 {
		font-size: 20px;
		line-height: 24px;
		height: 24px
	}

	.judgeVenueStatus_isBanned__2cpSM .judgeVenueStatus_mask__1Csuz .judgeVenueStatus_twoContentMaskContent__2j8iO {
		width: 270px;
		height: 180px;
		top: 60px
	}

	.judgeVenueStatus_isBanned__2cpSM .judgeVenueStatus_mask__1Csuz .judgeVenueStatus_twoContentMaskContent__2j8iO>section {
		display: -webkit-flex;
		display: flex;
		-webkit-justify-content: space-between;
		justify-content: space-between;
		-webkit-align-items: center;
		align-items: center;
		margin-top: 15px
	}

	.judgeVenueStatus_isBanned__2cpSM .judgeVenueStatus_mask__1Csuz .judgeVenueStatus_twoContentMaskContent__2j8iO>section p {
		line-height: 20px;
		font-size: 18px;
		margin-left: 12px;
		margin-right: 12px
	}

	.judgeVenueStatus_isBanned__2cpSM .judgeVenueStatus_mask__1Csuz .judgeVenueStatus_twoContentMaskContent__2j8iO .judgeVenueStatus_time__W_4q9 {
		font-size: 20px;
		line-height: 24px;
		height: 24px;
		margin-top: 5px
	}

	.logoBg_logoBgView {
		width: 50px;
		height: 50px;
		-webkit-flex: none;
		flex: none;
		margin-right: 8px;
		border-radius: 10.9px;
		display: -webkit-flex;
		display: flex;
		-webkit-align-items: center;
		align-items: center;
		-webkit-justify-content: center;
		justify-content: center;
		box-shadow: 0 3px 7px 0 rgba(112, 146, 215, .14);
		background-size: contain;
		// background-image:url(../../../assets/header/header-nav-2/icon60.png)
		background-image:url(/assets/header/header-nav-2/icon60.png)
	}

	.officialLogo_officialLogoView {
		width: 51px;
		height: 16px;
		background-size: contain;
		position: relative;
		// background-image:url(../../../assets/header/header-nav-2/icon15.png)
		background-image:url(/assets/header/header-nav-2/icon15.png)
	}

	.officialLogo_officialLogoView span {
		position: absolute;
		top: 50%;
		left: 23px;
		font-size: 12px;
		font-weight: 500;
		line-height: 16px;
		color: #fff;
		-webkit-transform: translateY(-50%);
		transform: translateY(-50%)
	}
</style>
